<div class="tt-c-ask">
  <div id="tt-c-ask-label" class="tt-c-ask__label" role="heading" :aria-level="iaConfig.headingLevel">
    <span class="tt-c-ask__label-text tt-u-show-until--md" v-html="askLabelMobile"></span>
    <span class="tt-c-ask__label-text tt-u-hide-until--md" v-html="askLabel"></span>
  </div>
  <tt-search-field @update:modelValue="updateText" :value="modelValue" :multiline="true" class="tt-c-ask__field" labelId="tt-c-ask-label" describedBy="tt-c-ask-hint"></tt-search-field>
  <tt-hint-text v-if="hintText" id="tt-c-ask-hint" class="tt-c-ask__hint" :type="hintType" :text="hintText">
    <a v-if="showLearnMoreLink" 
       href="#tt-c-ask-tips" 
       class="tt-c-ask__learn-more"
       aria-controls="tt-c-ask-tips"
       :aria-expanded="showLearnMore.toString()"
       @click.prevent="toggleLearnMore()"
       @keydown.enter.prevent="toggleLearnMore()"
       rel="nofollow"
       v-html="learnMoreText"></a>
  </tt-hint-text>
  <tt-ask-tips v-show="showLearnMore" id="tt-c-ask-tips"></tt-ask-tips>
</div>